import { render, staticRenderFns } from "./RemoveAccount.vue?vue&type=template&id=43085c3b&scoped=true&"
import script from "./RemoveAccount.vue?vue&type=script&lang=js&"
export * from "./RemoveAccount.vue?vue&type=script&lang=js&"
import style0 from "./RemoveAccount.vue?vue&type=style&index=0&id=43085c3b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43085c3b",
  null
  
)

export default component.exports